export default {
  plantillasDisponibles: [
    {
      value: 'home',
      text: 'Home (defecto)',
      component: 'HomePropio'
    },
    {
      value: 'about',
      text: 'Quienes Somos (defecto)',
      component: 'AboutPropio'
    }
  ]
}